import React from "react";
import { Box, Button } from "@mui/material";
import AxionControls from "../../../components/controls/AxionControls";
import { FormattedMessage } from "react-intl";
import messages from "./messages";
import Controls from "../../../components/controls/Controls";
import Checkbox from "../../../components/controls/Checkbox";

export default function AddEditAutocodeSchedule(props) {
    let stopReasonCodesForAutocoding = props.stopReasonCodes?.filter(x => x.canBeUsedForAutocoding === true);
    const departmentMachineType = props.machineTypes?.find(x => x.showInActivitySpecialList === true);
    const filteredMachines = props.machines.filter((machine) => { return machine.machineTypeId !== departmentMachineType?.id });

    function calculateEndTime(startTimeStr, lengthInMinutes) {
        if (!startTimeStr || isNaN(lengthInMinutes)) return "";

        const [hours, minutes, seconds] = startTimeStr.split(":").map(Number);
        // Use a fixed anchor date to see if the end time crosses into the next day
        const start = new Date(2000, 0, 1, hours, minutes, seconds);
        const end = new Date(start.getTime() + lengthInMinutes * 60000);

        const endHours = end.getHours().toString().padStart(2, '0');
        const endMinutes = end.getMinutes().toString().padStart(2, '0');
        const endSeconds = end.getSeconds().toString().padStart(2, '0');

        const isNextDay = end.getDate() > start.getDate();
        const isTwoDaysLater = end.getDate() > start.getDate() + 1;
        const isThreeDaysLater = end.getDate() > start.getDate() + 2;

        return `${endHours}:${endMinutes}${isThreeDaysLater ? " +3" : isTwoDaysLater ? " +2" : isNextDay ? " +1" : ""}`;
    }

    const optionsWithEndTime = props.lengthOptions.map(opt => ({
        id: opt.id,
        title: `${opt.label} (${calculateEndTime(props.autocodeSchedule.startTime, opt.id)})`
    }));

    return (
        <Box
            sx={{
                p: 1,
                m: 1
            }}>
            <Box>
                <AxionControls.AxionTextBox
                    name="name"
                    label={<FormattedMessage {...messages.nameColumn} />}
                    value={props.autocodeSchedule.name}
                    onChange={props.onChange}
                />
            </Box>
            <AxionControls.AxionSelect
                sx={{ marginTop: '12px' }}
                options={stopReasonCodesForAutocoding.map((item) => {
                    return {
                        id: item.id,
                        title: item.name
                    }
                }
                )}
                showNoneOption={true}
                name="stopReasonCodeId"
                label={<FormattedMessage {...messages.autocodeStopReasonCodeColumn} />}
                value={props.autocodeSchedule.stopReasonCodeId}
                onChange={props.onChange}
            />
            <Box>
                <AxionControls.AxionTextBoxTimeMask
                    name="startTime"
                    label={<FormattedMessage {...messages.startTimeColumn} />}
                    value={props.autocodeSchedule.startTime}
                    onChange={props.onChange}
                />
            </Box>
            <Box>
                <AxionControls.AxionSelect
                    name="lengthInMinutes"
                    sx={{ marginTop: '12px', width: '200px'}}
                    options={optionsWithEndTime}
                    showNoneOption={false}
                    label={<FormattedMessage {...messages.lengthInMinutesColumn} />}
                    value={props.autocodeSchedule.lengthInMinutes}
                    onChange={props.onChange}
                    disabled={props.autocodeSchedule.useCustomLength}
                />
                <Checkbox
                    name="useCustomLength"
                    sx={{ marginLeft: '16px', marginTop: '24px' }}
                    label={<FormattedMessage {...messages.useCustomLength} />}
                    value={props.autocodeSchedule.useCustomLength}
                    onChange={props.onChange}
                />
                <AxionControls.AxionTextBox
                    name="customLengthInMinutes"
                    sx={{ width: '200px' }}
                    label={<FormattedMessage {...messages.customLengthInMinutes} />}
                    value={props.autocodeSchedule.customLengthInMinutes}
                    onChange={props.onChange}
                    disabled={!props.autocodeSchedule.useCustomLength}
                />
            </Box>
            <Box 
                marginTop="12px" 
                sx={{ 
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignContent: 'flex-start', 
                    }
                    }>
                <Box>
                    <Controls.Checkbox
                        sx={{flex: "0 0 14,3%;"}}
                        name="mondayActive"
                        label={<FormattedMessage {...messages.mondayActive} />}
                        value={props.autocodeSchedule.mondayActive}
                        onChange={props.onChange}
                    />
                </Box>
                <Box>
                    <Controls.Checkbox
                        sx={{flex: "0 0 14,3%;"}}
                        name="tuesdayActive"
                        label={<FormattedMessage {...messages.tuesdayActive} />}
                        value={props.autocodeSchedule.tuesdayActive}
                        onChange={props.onChange}
                    />
                </Box>
                <Box>
                    <Controls.Checkbox
                        sx={{flex: "0 0 14,3%;"}}
                        name="wednesdayActive"
                        label={<FormattedMessage {...messages.wednesdayActive} />}
                        value={props.autocodeSchedule.wednesdayActive}
                        onChange={props.onChange}
                    />
                </Box>
                <Box>
                    <Controls.Checkbox
                        sx={{flex: "0 0 14,3%;"}}
                        name="thursdayActive"
                        label={<FormattedMessage {...messages.thursdayActive} />}
                        value={props.autocodeSchedule.thursdayActive}
                        onChange={props.onChange}
                    />
                </Box>
                <Box>
                    <Controls.Checkbox
                        sx={{flex: "0 0 14,3%;"}}
                        name="fridayActive"
                        label={<FormattedMessage {...messages.fridayActive} />}
                        value={props.autocodeSchedule.fridayActive}
                        onChange={props.onChange}
                    />
                </Box>
                <Box>
                    <Controls.Checkbox
                        sx={{flex: "0 0 14,3%;"}}
                        name="saturdayActive"
                        label={<FormattedMessage {...messages.saturdayActive} />}
                        value={props.autocodeSchedule.saturdayActive}
                        onChange={props.onChange}
                    />
                </Box>
                <Box>
                    <Controls.Checkbox
                        sx={{flex: "0 0 14,3%;"}}
                        name="sundayActive"
                        label={<FormattedMessage {...messages.sundayActive} />}
                        value={props.autocodeSchedule.sundayActive}
                        onChange={props.onChange}
                    />
                </Box>
            </Box>
            {Array.isArray(filteredMachines) && filteredMachines.length > 0 && (
                <Box sx={{ marginTop: '12px' }}>
                    <Box sx={{ marginBottom: '8px' }}>
                        <FormattedMessage {...messages.machinesColumn} />
                    </Box>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                        {filteredMachines.map((machine) => {
                            const isChecked = props.autocodeSchedule.machines?.some(m => m.id === machine.id);

                            return (
                                <Box key={machine.id} sx={{ marginRight: '16px', marginBottom: '8px' }}>
                                    <Controls.Checkbox
                                        name={`machine_${machine.id}`}
                                        label={machine.machineName}
                                        value={isChecked}
                                        onChange={(e) => {
                                            let newMachines;

                                            if (isChecked) {
                                                // Remove the machine
                                                newMachines = props.autocodeSchedule.machines.filter(m => m.id !== machine.id);
                                            } else {
                                                // Add the machine
                                                newMachines = [...(props.autocodeSchedule.machines || []), machine];
                                            }

                                            props.onChange({
                                                target: {
                                                    name: "machines",
                                                    value: newMachines
                                                }
                                            });
                                        }}
                                    />
                                </Box>
                            );
                        })}
                    </Box>
                </Box>
            )}
            <Box sx={{ marginTop: '12px' }}>
                <Box sx={{ marginBottom: '8px' }}>
                    <FormattedMessage {...messages.splitOngoingStops} />
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                    <Box sx={{ marginRight: '16px', marginBottom: '8px' }}>
                        <Controls.Checkbox
                            name="splitOngoingStopOnAutocodeStart"
                            label={<FormattedMessage {...messages.splitOngoingStopOnAutocodeStart} />}
                            value={props.autocodeSchedule.splitOngoingStopOnAutocodeStart}
                            onChange={props.onChange}
                        />
                    </Box>
                    <Box sx={{ marginRight: '16px', marginBottom: '8px' }}>
                        <Controls.Checkbox
                            name="splitOngoingStopOnAutocodeEnd"
                            label={<FormattedMessage {...messages.splitOngoingStopOnAutocodeEnd} />}
                            value={props.autocodeSchedule.splitOngoingStopOnAutocodeEnd}
                            onChange={props.onChange}
                        />
                    </Box>
                </Box>
            </Box>
            <Box>
                <Button
                    variant="contained"
                    sx={{
                        marginTop: 2,
                    }}
                    onClick={props.handleSave}>
                    <FormattedMessage {...messages.save} />
                </Button>
            </Box>
        </Box>
    );
}